import { doc } from "prettier";
document.addEventListener("DOMContentLoaded", function () {
  window.scrollCustomValue = 0;
  if (document.querySelector(".search-block-header-button")) {
    const bth = document.querySelector(".search-block-header-button");
    const bthCloseSearch = document.querySelector(".close-search-icon");
    const wrap = document.querySelector(".js-site-head_wrap");
    let funcCloseOpenSearch = () => {
      if (wrap.classList.contains('open-search')) {
        wrap.classList.remove('open-search');
      } else {
        wrap.classList.add('open-search');
      }
    };
    bth.addEventListener("click", funcCloseOpenSearch);
    bthCloseSearch.addEventListener("click", funcCloseOpenSearch);
  }
  if (document.querySelector(".js-search-block-acc-link")) {
    const bthAcc = document.querySelector(".js-search-block-acc-link");
    const wrapper = document.querySelector(".js-site-head_wrap");
    bthAcc.addEventListener("click", () => {
      if (wrapper.classList.contains('open-acc')) {
        wrapper.classList.remove('open-acc');
      } else {
        wrapper.classList.add('open-acc');
      }
    });
  }
  let callbackTimerId;
  let blocks = document.querySelectorAll('.js-products-view-block');
  const setHeight = () => {
    blocks.forEach(elem => {
      elem.children[0].style.height = elem.children[0].clientWidth * 4 / 3 + 'px';
    });
  };
  setTimeout(setHeight, 1000);
  $(window).on('resize', () => {
    if (callbackTimerId != null) {
      clearTimeout(callbackTimerId);
    }
    blocks.forEach(elem => {
      elem.children[0].style.height = 'auto';
    });
    callbackTimerId = setTimeout(setHeight, 250);
  });
});
$(window).bind('mousewheel', function (event) {
  let header = $("body.cs-t-1.text-floating .stretch-container header.site-head");
  if (header.length > 0) {
    if (event.originalEvent.wheelDelta >= 0) {
      if (header.hasClass("close-one-part") && !header.hasClass("close-two-part") && pageYOffset < 120) {
        window.scrollCustomValue = pageYOffset;
        header.removeClass("close-one-part");
        //$($('.site-head_logo-wrap')).slideDown();
      } else {
        window.scrollCustomValue = pageYOffset;
        header.removeClass("close-two-part");
      }
    } else if (event.originalEvent.wheelDelta <= -120) {
      if (!header.hasClass("close-one-part")) {
        window.scrollCustomValue = pageYOffset;
        header.addClass("close-one-part");
        //$($('.site-head_logo-wrap')).slideUp();
      } else if (header.hasClass("close-one-part") && window.scrollCustomValue < pageYOffset) {
        window.scrollCustomValue = pageYOffset;
        header.addClass("close-two-part");
      }
    }
  }
});